'use client';

import { useEffect, useState } from 'react';
import './industry-page.css';

const iconProps = { viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 1.8, strokeLinecap: 'round', strokeLinejoin: 'round' };

function IconCart() {
  return (
    <svg {...iconProps}>
      <circle cx="9" cy="20" r="1" fill="currentColor" stroke="none" />
      <circle cx="18" cy="20" r="1" fill="currentColor" stroke="none" />
      <path d="M2 3h2l2.4 12.2a2 2 0 0 0 2 1.6h8.2a2 2 0 0 0 2-1.6L21 7H6" />
    </svg>
  );
}

function IconBolt() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2 4 14h6l-1 8 9-13h-6z" />
    </svg>
  );
}

function IconGear() {
  return (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="3" />
      <path d="M12 2v3M12 19v3M4.2 4.2l2.1 2.1M17.7 17.7l2.1 2.1M2 12h3M19 12h3M4.2 19.8l2.1-2.1M17.7 6.3l2.1-2.1" />
    </svg>
  );
}

function IconPharma() {
  return (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 8v8M8 12h8" />
    </svg>
  );
}

function IconBuilding() {
  return (
    <svg {...iconProps}>
      <rect x="4" y="3" width="16" height="18" rx="1" />
      <path d="M8 7h2M14 7h2M8 11h2M14 11h2M8 15h2M14 15h2M10 21v-4h4v4" />
    </svg>
  );
}

function IconBank() {
  return (
    <svg {...iconProps}>
      <path d="M3 10l9-6 9 6" />
      <path d="M4 10v9M9 10v9M15 10v9M20 10v9" />
      <path d="M2 21h20" />
    </svg>
  );
}

function IconPlane() {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor">
      <path d="M22 16v-2l-8.5-5V3.5a1.5 1.5 0 0 0-3 0V9L2 14v2l8.5-2.5V19L8 20.5V22l4-1 4 1v-1.5L13.5 19v-5.5L22 16z" />
    </svg>
  );
}

function IconBriefcase() {
  return (
    <svg {...iconProps}>
      <rect x="2" y="7" width="20" height="13" rx="2" />
      <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" />
      <path d="M2 13h20" />
    </svg>
  );
}

function IconSearch() {
  return (
    <svg {...iconProps}>
      <circle cx="11" cy="11" r="7" />
      <path d="M21 21l-4.3-4.3" />
    </svg>
  );
}

function IconCompass() {
  return (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="9" />
      <path d="M15 9l-2 6-6 2 2-6 6-2z" />
    </svg>
  );
}

function IconChartUp() {
  return (
    <svg {...iconProps}>
      <path d="M4 20V10M12 20V4M20 20v-7" />
    </svg>
  );
}

function IconRocket() {
  return (
    <svg {...iconProps}>
      <path d="M12 2c3 2 5 6 5 10 0 2-1 4-2 5l-1-3-2 2-2-2-1 3c-1-1-2-3-2-5 0-4 2-8 5-10z" />
      <circle cx="12" cy="10" r="1.3" fill="currentColor" stroke="none" />
    </svg>
  );
}

function IconTarget() {
  return (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="9" />
      <circle cx="12" cy="12" r="5" />
      <circle cx="12" cy="12" r="1" fill="currentColor" stroke="none" />
    </svg>
  );
}

function IconTruck() {
  return (
    <svg {...iconProps}>
      <rect x="1" y="7" width="13" height="10" rx="1" />
      <path d="M14 10h4l3 3v4h-7z" />
      <circle cx="6" cy="19" r="1.6" />
      <circle cx="17" cy="19" r="1.6" />
    </svg>
  );
}

function IconTag() {
  return (
    <svg {...iconProps}>
      <path d="M12 2h7a1 1 0 0 1 1 1v7a2 2 0 0 1-.6 1.4l-8 8a2 2 0 0 1-2.8 0l-6-6a2 2 0 0 1 0-2.8l8-8A2 2 0 0 1 12 2z" />
      <circle cx="15.5" cy="8.5" r="1.5" fill="currentColor" stroke="none" />
    </svg>
  );
}

function IconUsers() {
  return (
    <svg {...iconProps}>
      <circle cx="9" cy="8" r="3" />
      <path d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6" />
      <circle cx="17" cy="9" r="2.5" />
      <path d="M15.5 14a5 5 0 0 1 5.5 5" />
    </svg>
  );
}

function IconLeaf() {
  return (
    <svg {...iconProps}>
      <path d="M5 21c8 0 14-6 14-14V4h-3C8 4 3 9 3 17v4z" />
      <path d="M5 21c3-3 6-6 14-14" />
    </svg>
  );
}

const industries = [
  [IconCart, 'FMCG & Retail'], [IconBolt, 'Energy & Utilities'], [IconGear, 'Manufacturing'],
  [IconPharma, 'Pharma & Life Sciences'], [IconBuilding, 'Hotels & Hospitality'], [IconBank, 'BFSI'],
  [IconPlane, 'Airlines & Airports'], [IconBriefcase, 'Professional Services'],
];

const industryLinks = {
  'FMCG & Retail': '/industries/fmcg-retail',
  'Energy & Utilities': '/industries/energy-utilities',
  'Manufacturing': '/industries/manufacturing',
  'Pharma & Life Sciences': '/industries/pharma-lifescience',
  'Hotels & Hospitality': '/industries/industry-hotel',
  'BFSI': '/industries/bfsi',
  'Airlines & Airports': '/industries/airlines-airports',
  'Professional Services': '/industries/professional-services',
};

const stories = [
  {
    slug: 'haldirams', logo: 'Haldiram’s', logoImg: '/assets/images/haldirams.png',
    title: 'Integrated finance, supply chain and retail operations across India and Nepal.',
    metrics: [{ value: '20%', label: 'Faster closing' }, { value: '15%', label: 'Lower inventory' }],
    image: 'https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=700&q=80',
  },
  {
    slug: 'zydus', logo: 'zydus wellness', logoImg: '/assets/images/zydus-wellness.png',
    title: 'Built AI-enabled sales & planning platform for faster, data-driven decisions.',
    metrics: [{ value: '30%', label: 'Better forecast accuracy' }],
    image: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=700&q=80',
  },
  {
    slug: 'dsgroup', logo: 'DS Group', logoImg: '/assets/images/ds-group.png',
    title: 'S/4HANA migration with 9 verticals and 5-year AMS.',
    metrics: [{ value: 'Higher', label: 'Process efficiency' }],
    image: 'https://images.unsplash.com/photo-1497366754035-f200968a6e72?auto=format&fit=crop&w=700&q=80',
  },
  {
    slug: 'biba', logo: 'BIBA',
    title: 'Re-implementation and AMS to power business growth.',
    metrics: [{ value: 'Improved', label: 'Retail operations' }],
    image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?auto=format&fit=crop&w=700&q=80',
  },
];

const benefits = [
  [IconTarget, 'Integrated Planning & S&OP', 'Demand, supply, financial alignment'],
  [IconCart, 'Omnichannel Commerce', 'Store, online and marketplace'],
  [IconTruck, 'Supply Chain & Logistics', 'Plan, fulfil and deliver with agility'],
  [IconTag, 'Pricing & Promotions', 'Smarter decisions, higher margins'],
  [IconUsers, 'Customer & Channel Insights', 'Turn data into loyalty'],
  [IconLeaf, 'Sustainability & Compliance', 'Responsible and future-ready'],
];

const approach = [
  [IconSearch, '01', 'Understand', 'Your business, customers and goals.'],
  [IconCompass, '02', 'Design', 'Tailored solutions with industry best practices.'],
  [IconGear, '03', 'Implement', 'Using SAP and AI with agile delivery.'],
  [IconChartUp, '04', 'Operate', 'Ensure performance, adoption and continuous improvement.'],
  [IconRocket, '05', 'Grow', 'Unlock new opportunities and long-term value.'],
];

export default function IndustryPage() {
  const [storyOffset, setStoryOffset] = useState(0);
  const [slideDir, setSlideDir] = useState('');
  const visibleStories = stories.map((_, i) => stories[(i + storyOffset) % stories.length]);

  useEffect(() => {
    const cards = document.querySelectorAll(
      ".industry-tabs button, .industry-feature-panel, .industry-benefit-row, .industry-approach-item, .industry-story-carousel"
    );

    if (!("IntersectionObserver" in window)) {
      cards.forEach((card) => card.classList.add("in-view"));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in-view");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: "0px 0px -60px 0px" }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  return (
    <>
    <main className="industry-page">
      <section
        className="industry-hero-section"
        style={{ backgroundImage: "url(/assets/images/industryhero.png)" }}
      >
        <div className="industry-hero-copy">
          <h1>Industry Knowledge.<br /><span>Real Business Impact.</span></h1>
          <p>Deep domain understanding. Proven SAP and AI capabilities. Measurable outcomes across industries and geographies.</p>
          <div className="industry-hero-actions">
            <a className="fp-buttons fp-btn-primary industry-primary-btn" href="#industries">
              Explore Industries <span aria-hidden="true">→</span>
            </a>
          </div>
        </div>
      </section>

      <section id="industries" className="industry-tabs">
        {industries.map(([Icon, name], index) => (
          <a href={industryLinks[name]} className={index === 0 ? 'active' : ''} key={name}>
            <b><Icon /></b>
            <span>{name}</span>
          </a>
        ))}
      </section>

      <section className="industry-fmcg-section industry-section-grid">
        <div className="industry-section-copy">
          <span className="industry-eyebrow">FMCG & RETAIL</span>
          <h2>From Shelf to<br /><span>Sustainable Growth.</span></h2>
          <p>We help FMCG and retail companies simplify operations, improve customer experience and unlock growth with SAP and AI.</p>
          <div className="industry-stats"><div><strong>200+</strong><small>Implementations<br />& support projects</small></div><div><strong>15%+</strong><small>Average improvement<br />in supply chain efficiency</small></div><div><strong>20%+</strong><small>Better forecast<br />accuracy</small></div><div><strong>10%+</strong><small>Increase in<br />revenue realisation</small></div></div>
          <a className="industry-outline-btn" href="/industries/fmcg-retail">EXPLORE FMCG & RETAIL →</a>
        </div>
        <div className="industry-feature-panel"><img src="/assets/images/fmg.png" alt="Retail store" /><div className="industry-feature-overlay"><h3>Connected<br />Enterprises for<br />a Hungrier World.</h3></div></div>
        <div className="industry-benefits">
          {benefits.map(([Icon, title, desc]) => (
            <div className="industry-benefit-row" key={title}>
              <div className="industry-benefit-icon"><Icon /></div>
              <div className="industry-benefit-text">
                <b>{title}</b>
                <span>{desc}</span>
              </div>
              <span className="industry-benefit-chevron">›</span>
            </div>
          ))}
        </div>
      </section>

      <section id="stories" className="industry-stories">
        <div className="industry-section-heading">
          <div>
            <span className="industry-eyebrow">SUCCESS STORIES</span>
            <h2>Real Companies. <span>Real Outcomes.</span></h2>
          </div>
          <a href="/customers/Customer-Stories">View All Case Studies →</a>
        </div>

        <div className="industry-story-carousel">
          <button
            className="industry-story-arrow industry-story-arrow-prev"
            aria-label="Previous stories"
            onClick={() => {
              setSlideDir('prev');
              setStoryOffset((o) => (o - 1 + stories.length) % stories.length);
            }}
          >
            ←
          </button>
          <button
            className="industry-story-arrow industry-story-arrow-next"
            aria-label="Next stories"
            onClick={() => {
              setSlideDir('next');
              setStoryOffset((o) => (o + 1) % stories.length);
            }}
          >
            →
          </button>

          <div
            className={`industry-story-grid${slideDir ? ` industry-story-slide-${slideDir}` : ''}`}
            key={storyOffset}
          >
       {visibleStories.map((story, index) => (
  <article
    className="industry-story-card"
    key={story.slug}
    style={{
      '--story-index': index,
    }}
  >
                <div className="industry-story-image">
                  <div className="industry-story-logo-panel">
                    {story.logoImg ? (
                      <img className="industry-story-logo-img" src={story.logoImg} alt={story.logo} />
                    ) : (
                      <span className={`industry-story-logo industry-story-logo-${story.slug}`}>{story.logo}</span>
                    )}
                  </div>
                  <img src={story.image} alt="" />
                </div>

                <p>{story.title}</p>

                <div className="industry-story-metrics">
                  {story.metrics.map((metric) => (
                    <div key={metric.label}>
                      <strong>{metric.value}</strong>
                      <small>{metric.label}</small>
                    </div>
                  ))}
                </div>

                <a href="/customers/Customer-Stories">Read the case →</a>
              </article>
            ))}
          </div>
        </div>

        <div className="industry-story-dots">
          {stories.map((story, i) => (
            <span key={story.slug} className={i === storyOffset ? 'active' : ''} />
          ))}
        </div>
      </section>

      <section className="industry-approach">
        <span className="industry-eyebrow">OUR APPROACH</span>
        <div className="industry-section-heading">
          <h2>From Industry Challenges <span>to Measurable Value.</span></h2>
          <a href="/whatwedo">Learn More About Our Approach →</a>
        </div>
        <div className="industry-approach-grid">
          {approach.flatMap(([Icon, num, title, desc], index) => {
            const nodes = [
              <div className="industry-approach-item" key={`item-${num}`}>
                <div className="industry-approach-head">
                  <div className="industry-round-icon"><Icon /></div>
                  <b>{num}. {title}</b>
                </div>
                <p>{desc}</p>
              </div>,
            ];
            if (index < approach.length - 1) {
              nodes.push(<span className="industry-approach-connector" key={`arrow-${num}`}>→</span>);
            }
            return nodes;
          })}
        </div>
      </section>
    </main>

      <section
        className="industry-bottom-cta"
        style={{ backgroundImage: "url(/assets/images/ctaindusrty.png)" }}
      >
        <div className="industry-bottom-cta-copy">
          <span className="industry-eyebrow">LET’S BUILD WHAT’S NEXT</span>
          <h2>Ready to transform your industry?</h2>
          <p>Bring us your business problem. Let’s create real value together.</p>
          <a className="fp-buttons fp-btn-primary industry-cta-btn" href="/tellusyourproblem#tell-details">
            Tell Us Your Problem <span aria-hidden="true">→</span>
          </a>
        </div>
      </section>
    </>
  );
}